:host {
  /**
   * @prop --padding: padding around any content. Only relevent on `<nano-img background>`
  */
  --padding: 0;

  display: inline-block;
  object-fit: cover;
  object-position: center;
  background-size: cover;
  background-position: center;

  * {
    border-radius: inherit;
  }
}

:host([background]:not([background='false'])) {
  display: block;
}

.img {
  position: relative;
  min-block-size: inherit;
  block-size: 100%;
  display: block;
  object-fit: inherit;
  object-position: inherit;
  background-color: inherit;
  background-position: inherit;
  background-size: inherit;
  background-origin: inherit;
  background-attachment: inherit;
  background-repeat: inherit;
}

.img__loader,
.img__observer {
  position: absolute;
  inset: 0;
  block-size: 100%;
  inline-size: 100%;
  z-index: -1;
}

.img__image,
.img__bg {
  border-radius: inherit;
  display: block;
  opacity: 0;
  transition: 0.5s ease opacity, 0.3s ease filter 0.4s;
  filter: blur(5px);

  &.loaded {
    opacity: 1;
    filter: blur(0.1px);

    @media not all and (min-resolution: 0.001dpcm) {
      @supports (-webkit-appearance: none) {
        filter: blur(0);
      }
    }
  }
}

.img__image {
  object-fit: inherit;
  object-position: inherit;
  max-inline-size: 100%;
  block-size: auto;

  &.hide {
    visibility: hidden;

    &.no-height {
      block-size: 1px;
      position: absolute;
      z-index: -1;
    }
  }
}

.img__bg {
  background-color: inherit;
  background-position: inherit;
  background-size: inherit;
  background-origin: inherit;
  background-attachment: inherit;
  background-repeat: inherit;
  overflow: auto;
  padding: var(--padding);

  &.no-height {
    position: absolute;
    inset: 0;
  }
}
